import { useCallback } from 'react';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { getBorderClassNames } from '@nx-frontend/shared/themes';
import { PortalBorderType, PortalStyleConfig, ThemeColorSchemas } from '@nx-frontend/shared/types';
import { PromptType } from './types';

interface ChatbotPromptComponent {
  text: string;
  onClick: (text: string, promptType: PromptType) => void;
  themeColors?: ThemeColorSchemas;
  themeStyle?: PortalStyleConfig;
  bordered?: boolean;
  promptType: PromptType;
}

export function ChatbotPromptComponent({
  text,
  onClick,
  themeColors,
  themeStyle,
  bordered,
  promptType,
}: ChatbotPromptComponent) {
  const onPromptClick = useCallback(() => {
    onClick(text, promptType);
  }, [onClick, text, promptType]);

  return (
    <div
      className={classNames(
        'flex items-center rounded-lg py-[9px] px-3 cursor-pointer transition-colors duration-200 hover:bg-neutral-100',
        bordered && themeColors && themeStyle && getBorderClassNames(themeColors, themeStyle, PortalBorderType.SURFACE)
      )}
      onClick={onPromptClick}
    >
      <Icon icon={IconsMap.AI_2} className="w-[20px] text-[#FBBF24] flex-shrink-0" />
      <span className="ml-2 text-sm block overflow-hidden text-ellipsis whitespace-nowrap" title={text}>
        {text}
      </span>
    </div>
  );
}
